const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'User',
        dataIndex: 'user',
        render: defaultRender,
    },
    {
        title: 'Title',
        dataIndex: 'title',
        render: defaultRender,
    },
    {
        title: 'Version',
        dataIndex: 'version',
        render: defaultRender,
    },
    {
        title: 'Documents',
        dataIndex: 'documents',
        render: defaultRender,
    },
    {
        title: 'Accepted Date',
        dataIndex: 'acceptedDate',
        render: defaultRender,
    },
];

export default columns;
